// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Pervasives from "../../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as FareStrategy from "../../../../../app/order/entity/FareStrategy.bs.js";
import * as BreachInfoThreshold from "../../../../../../../../library/data-source/order/entity/BreachInfoThreshold.bs.js";

function getVm(order) {
  if (order.TAG !== /* Ended */3) {
    return {
            create_fare_trip_strategy: Belt_Option.mapWithDefault(order._0.create_trip_fare_strategy, "N/A", (function (c) {
                    return FareStrategy.CreateTrip.toString(c);
                  })),
            end_fare_trip_strategy: "N/A",
            pickup_vicinity_passed: "N/A",
            drop_vicinity_passed: "N/A",
            waypoint_vicinity_passed: "N/A",
            breach_type: "N/A",
            waiting_time_passed: "N/A",
            new_fixed_fare_fixed_greater: "N/A"
          };
  }
  var ended_order = order._3;
  return {
          create_fare_trip_strategy: Belt_Option.mapWithDefault(order._0.create_trip_fare_strategy, "N/A", (function (c) {
                  return FareStrategy.CreateTrip.toString(c);
                })),
          end_fare_trip_strategy: Belt_Option.mapWithDefault(ended_order.end_trip_fare_strategy, "N/A", (function (c) {
                  return FareStrategy.EndTrip.toString(c);
                })),
          pickup_vicinity_passed: Belt_Option.mapWithDefault(ended_order.breach_info, "N/A", (function (i) {
                  return $$String.capitalize_ascii(BreachInfoThreshold.toString(i.pickup_vicinity_passed));
                })),
          drop_vicinity_passed: Belt_Option.mapWithDefault(ended_order.breach_info, "N/A", (function (i) {
                  return $$String.capitalize_ascii(BreachInfoThreshold.toString(i.drop_vicinity_passed));
                })),
          waypoint_vicinity_passed: Belt_Option.mapWithDefault(ended_order.breach_info, "N/A", (function (i) {
                  return $$String.capitalize_ascii(BreachInfoThreshold.toString(i.waypoint_vicinity_passed));
                })),
          breach_type: Belt_Option.mapWithDefault(ended_order.breach_info, "N/A", (function (i) {
                  return $$String.capitalize_ascii(i.breach_type);
                })),
          waiting_time_passed: Belt_Option.mapWithDefault(ended_order.breach_info, "N/A", (function (i) {
                  return $$String.capitalize_ascii(BreachInfoThreshold.toString(i.waiting_time_passed));
                })),
          new_fixed_fare_fixed_greater: Belt_Option.mapWithDefault(ended_order.breach_info, "N/A", (function (i) {
                  return Belt_Option.mapWithDefault(i.fixed_fallback_fare_is_higher, "N/A", (function (f) {
                                return $$String.capitalize_ascii(Pervasives.string_of_bool(f));
                              }));
                }))
        };
}

export {
  getVm ,
  
}
/* No side effect */
